<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs v-model="activeTab">
        <a-tab-pane key="country" tab="国家管理">
          <div class="table-page-search-wrapper">
            <a-button type="primary" @click="handleAddCountry"><a-icon type="plus" />新增国家</a-button>
          </div>
          <a-table :loading="countryLoading" rowKey="id" :columns="countryColumns" :data-source="countryManageList" :pagination="false">
            <span slot="logoUrl" slot-scope="text">
              <img v-if="text" :src="text" style="width:48px;height:48px;object-fit:contain" />
            </span>
            <span slot="status" slot-scope="text">
              <a-tag v-if="text === 1" color="green">启用</a-tag>
              <a-tag v-else color="red">禁用</a-tag>
            </span>
            <span slot="operation" slot-scope="text, record">
              <a @click="handleEditCountry(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleDeleteCountry(record)">删除</a>
            </span>
          </a-table>
          <a-pagination
            class="ant-table-pagination"
            :current="countryQuery.pageNum"
            :total="countryTotal"
            :page-size="countryQuery.pageSize"
            @change="changeCountryPage"
          />
        </a-tab-pane>

        <a-tab-pane key="category" tab="卡种管理">
          <div class="table-page-search-wrapper">
            <a-button type="primary" @click="handleAddCategory"><a-icon type="plus" />新增卡种</a-button>
          </div>
          <a-table :loading="categoryLoading" rowKey="id" :columns="categoryColumns" :data-source="categoryList" :pagination="false">
            <span slot="logoUrl" slot-scope="text">
              <img v-if="text" :src="text" style="width:48px;height:48px;object-fit:contain" />
            </span>
            <span slot="needCardNumber" slot-scope="text">{{ text === 1 ? '✓' : '—' }}</span>
            <span slot="needCardExpiry" slot-scope="text">{{ text === 1 ? '✓' : '—' }}</span>
            <span slot="needCardPin" slot-scope="text">{{ text === 1 ? '✓' : '—' }}</span>
            <span slot="status" slot-scope="text">
              <a-tag v-if="text === 1" color="green">启用</a-tag>
              <a-tag v-else color="red">禁用</a-tag>
            </span>
            <span slot="operation" slot-scope="text, record">
              <a @click="handleEditCategory(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleDeleteCategory(record)">删除</a>
            </span>
          </a-table>
          <a-pagination
            class="ant-table-pagination"
            :current="categoryQuery.pageNum"
            :total="categoryTotal"
            :page-size="categoryQuery.pageSize"
            @change="changeCategoryPage"
          />
        </a-tab-pane>

        <a-tab-pane key="tier" tab="面额阶梯价">
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="16" type="flex" align="middle">
                <a-col :xl="5" :lg="6" :md="6" :sm="12">
                  <a-form-item label="卡种">
                    <a-select v-model="tierQuery.categoryId" allowClear placeholder="全部" style="width:100%" @change="handleTierQuery">
                      <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="5" :lg="6" :md="6" :sm="12">
                  <a-form-item label="国家">
                    <a-select v-model="tierQuery.countryId" allowClear placeholder="全部" style="width:100%" @change="handleTierQuery">
                      <a-select-option v-for="c in countryList" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="4" :lg="5" :md="4" :sm="12">
                  <a-form-item label="卡类型">
                    <a-select v-model="tierQuery.cardType" allowClear placeholder="全部" style="width:100%" @change="handleTierQuery">
                      <a-select-option :value="1">实体卡</a-select-option>
                      <a-select-option :value="2">卡密</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xl="10" :lg="7" :md="8" :sm="24">
                  <span class="table-page-search-submitButtons">
                    <a-button type="primary" @click="handleAddTier"><a-icon type="plus" />新增阶梯价</a-button>
                    <a-button style="margin-left: 8px" @click="openTierSyncDrawer"><a-icon type="sync" />批量同步</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <a-card size="small" title="全局配置" style="margin-bottom: 16px">
            <a-form-model layout="inline">
              <a-form-model-item label="当日N汇率" required>
                <a-input-number
                  v-model="tierGlobalConfig.dailyNRate"
                  :min="0.0001"
                  :step="0.0001"
                  :precision="4"
                  style="width: 160px"
                  placeholder="请先配置"
                />
              </a-form-model-item>
              <a-form-model-item>
                <a-button type="primary" :loading="tierConfigSubmitLoading" @click="submitTierGlobalConfig">保存配置</a-button>
              </a-form-model-item>
            </a-form-model>
            <div class="form-tip">当日N汇率全局生效；新增/编辑阶梯价时将自动带入且不可修改。默认价格 = 当日卡汇率 × 当日N汇率（取整）</div>
          </a-card>
          <a-alert
            message="Redeem Value 落在区间内时：Cash Value = Redeem Value × 默认价格（第1张）+ Redeem Value × 默认价格（第2张）+ …。默认价格 = 当日卡汇率 × 当日N汇率。"
            type="info"
            show-icon
            style="margin-bottom: 16px"
          />
          <a-table :loading="tierLoading" rowKey="id" :columns="tierColumns" :data-source="tierList" :pagination="false">
            <span slot="categoryId" slot-scope="text">{{ categoryName(text) }}</span>
            <span slot="countryId" slot-scope="text">{{ countryName(text) }}</span>
            <span slot="cardType" slot-scope="text">{{ text === 2 ? '卡密' : '实体卡' }}</span>
            <span slot="tierType" slot-scope="text">{{ text === 2 ? '百分比' : '区间范围' }}</span>
            <span slot="faceRange" slot-scope="text, record">{{ record.minFaceValue }} ~ {{ record.maxFaceValue }}</span>
            <span slot="dailyCardRate" slot-scope="text">{{ formatRate(text) }}</span>
            <span slot="dailyNRate" slot-scope="text">{{ formatRate(text) }}</span>
            <span slot="defaultPrice" slot-scope="text, record">{{ formatDefaultPrice(record.defaultPrice != null ? record.defaultPrice : record.rate) }}</span>
            <span slot="multiplier" slot-scope="text, record">{{ record.tierType === 2 ? text : '—' }}</span>
            <span slot="status" slot-scope="text">
              <a-tag v-if="text === 1" color="green">启用</a-tag>
              <a-tag v-else color="red">禁用</a-tag>
            </span>
            <span slot="operation" slot-scope="text, record">
              <a @click="handleEditTier(record)">编辑</a>
              <a-divider type="vertical" />
              <a @click="handleDeleteTier(record)">删除</a>
            </span>
          </a-table>
          <a-pagination
            class="ant-table-pagination"
            :current="tierQuery.pageNum"
            :total="tierTotal"
            :page-size="tierQuery.pageSize"
            @change="changeTierPage"
          />
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <a-modal :title="countryFormTitle" :visible="countryOpen" @ok="submitCountry" @cancel="closeCountryModal" :confirmLoading="countrySubmitLoading" width="560px">
      <a-form-model :model="countryForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item v-if="!isCountryEditing" label="选择国家" required>
          <a-select
            v-model="selectedWorldCountryCode"
            show-search
            allow-clear
            placeholder="输入国家名、中文或代码搜索"
            :filter-option="false"
            @search="onWorldCountrySearch"
            @change="onWorldCountryPick"
            style="width:100%"
          >
            <a-select-option v-for="c in availableWorldCountries" :key="c.code" :value="c.code">
              {{ c.nameZh }} · {{ c.name }} ({{ c.code }}) {{ c.currencySymbol }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="国家名称">
          <a-input v-model="countryForm.name" :disabled="!isCountryEditing" placeholder="选择国家后自动填充" />
        </a-form-model-item>
        <a-form-model-item label="国家代码">
          <a-input v-model="countryForm.code" :disabled="!isCountryEditing" placeholder="如 NG" />
        </a-form-model-item>
        <a-form-model-item label="货币符号">
          <a-input v-model="countryForm.currencySymbol" placeholder="如 ₦" />
        </a-form-model-item>
        <a-form-model-item label="图标">
          <file-upload v-model="countryForm.logoUrl" type="image" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="countryForm.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-model="countryForm.status" style="width:100%">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal :title="categoryFormTitle" :visible="categoryOpen" @ok="submitCategory" @cancel="categoryOpen = false" :confirmLoading="categorySubmitLoading">
      <a-form-model :model="categoryForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="名称">
          <a-input v-model="categoryForm.name" placeholder="如 Xbox、VISA" />
        </a-form-model-item>
        <a-form-model-item label="Logo">
          <file-upload v-model="categoryForm.logoUrl" type="image" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="categoryForm.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-model="categoryForm.status" style="width:100%">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="App 提交字段">
          <div class="card-field-checks">
            <a-checkbox :checked="categoryForm.needCardNumber === 1" @change="e => categoryForm.needCardNumber = e.target.checked ? 1 : 0">
              Card Number
            </a-checkbox>
            <a-checkbox :checked="categoryForm.needCardExpiry === 1" @change="e => categoryForm.needCardExpiry = e.target.checked ? 1 : 0">
              Card Expiry Date
            </a-checkbox>
            <a-checkbox :checked="categoryForm.needCardPin === 1" @change="e => categoryForm.needCardPin = e.target.checked ? 1 : 0">
              Card PIN
            </a-checkbox>
          </div>
          <div class="form-tip">勾选后 App 添加礼品卡页对每张卡展示对应输入项；未勾选则不展示且提交时不校验</div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal :title="tierFormTitle" :visible="tierOpen" @ok="submitTier" @cancel="tierOpen = false" :confirmLoading="tierSubmitLoading">
      <a-form-model :model="tierForm" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="卡种">
          <a-select v-model="tierForm.categoryId" placeholder="请选择卡种" style="width:100%">
            <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="国家">
          <a-select v-model="tierForm.countryId" placeholder="请选择国家" style="width:100%">
            <a-select-option v-for="c in countryList" :key="c.id" :value="c.id">{{ c.name }} ({{ c.currencySymbol }})</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="卡类型">
          <a-select v-model="tierForm.cardType" style="width:100%">
            <a-select-option :value="1">实体卡</a-select-option>
            <a-select-option :value="2">卡密</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="类型">
          <a-select v-model="tierForm.tierType" style="width:100%" @change="onTierTypeChange">
            <a-select-option :value="1">区间范围</a-select-option>
            <a-select-option :value="2">百分比</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="面额下限">
          <a-input-number v-model="tierForm.minFaceValue" :min="0" :step="1" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="面额上限">
          <a-input-number v-model="tierForm.maxFaceValue" :min="0" :step="1" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item v-if="tierForm.tierType === 2" label="倍数">
          <a-input-number v-model="tierForm.multiplier" :min="0" :step="0.0001" style="width:100%" placeholder="百分比类型必填" />
        </a-form-model-item>
        <a-form-model-item label="当日N汇率">
          <a-input-number
            :value="tierFormDailyNRate"
            :precision="4"
            style="width:100%"
            disabled
            placeholder="请先在页面顶部配置当日N汇率"
          />
        </a-form-model-item>
        <a-form-model-item label="当日卡汇率" required>
          <a-input-number
            v-model="tierForm.dailyCardRate"
            :min="0.0001"
            :step="0.0001"
            :precision="4"
            style="width:100%"
            placeholder="请输入当日卡汇率"
            @change="recalcTierDefaultPrice"
          />
        </a-form-model-item>
        <a-form-model-item label="默认价格">
          <a-input-number v-model="tierForm.defaultPrice" :min="1" :step="1" :precision="0" style="width:100%" disabled />
          <div style="color:#999;font-size:12px;margin-top:4px">
            自动计算：当日卡汇率 × 当日N汇率（取整）；单张 Cash Value = Redeem Value × 默认价格；多张为各张分别计算后相加
          </div>
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="tierForm.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-model="tierForm.status" style="width:100%">
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-drawer
      title="批量同步阶梯价"
      :visible="tierSyncOpen"
      width="480"
      :destroyOnClose="true"
      @close="closeTierSyncDrawer"
    >
      <a-alert
        type="info"
        show-icon
        message="按卡种与面额范围批量更新当日卡汇率、当日N汇率、默认价格"
        style="margin-bottom: 24px"
      />
      <a-form-model :model="tierSyncForm" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="卡种" required>
          <a-select
            v-model="tierSyncForm.categoryId"
            placeholder="请选择卡种"
            style="width:100%"
            @change="refreshTierSyncMatchCount"
          >
            <a-select-option v-for="c in categoryOptions" :key="c.id" :value="c.id">{{ c.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="面额下限">
          <a-input-number
            v-model="tierSyncForm.minFaceValue"
            :min="0"
            :step="1"
            placeholder="不限"
            style="width:100%"
            @change="refreshTierSyncMatchCount"
          />
        </a-form-model-item>
        <a-form-model-item label="面额上限">
          <a-input-number
            v-model="tierSyncForm.maxFaceValue"
            :min="0"
            :step="1"
            placeholder="不限"
            style="width:100%"
            @change="refreshTierSyncMatchCount"
          />
          <div class="form-tip">范围筛选阶梯价的 min/max 面额区间，留空表示该卡种下全部</div>
        </a-form-model-item>
        <a-form-model-item label="当日N汇率">
          <a-input-number
            :value="tierGlobalConfig.dailyNRate"
            :precision="4"
            style="width:100%"
            disabled
            placeholder="请先在列表页配置"
          />
        </a-form-model-item>
        <a-form-model-item label="当日卡汇率" required>
          <a-input-number
            v-model="tierSyncForm.dailyCardRate"
            :min="0.0001"
            :step="0.0001"
            :precision="4"
            style="width:100%"
            placeholder="请输入"
            @change="recalcTierSyncDefaultPrice"
          />
        </a-form-model-item>
        <a-form-model-item label="默认价格">
          <a-input-number
            v-model="tierSyncForm.defaultPrice"
            :precision="0"
            style="width:100%"
            disabled
          />
          <div class="form-tip">自动计算：当日卡汇率 × 当日N汇率（取整）</div>
        </a-form-model-item>
        <a-form-model-item label="匹配条数">
          <span v-if="tierSyncForm.categoryId"><b>{{ tierSyncMatchCount }}</b> 条</span>
          <span v-else class="form-tip">请先选择卡种</span>
        </a-form-model-item>
      </a-form-model>
      <div class="drawer-footer">
        <a-button style="margin-right: 8px" @click="closeTierSyncDrawer">取消</a-button>
        <a-button type="primary" :loading="tierSyncSubmitting" @click="submitTierSync">确认同步</a-button>
      </div>
    </a-drawer>
  </page-header-wrapper>
</template>

<script>
import { pageCategory, saveCategory, deleteCategory, listCountry, pageCountry, saveCountry, deleteCountry, pageRateTier, getRateTierConfig, saveRateTierConfig, syncRateTier, saveRateTier, deleteRateTier } from '@/api/giftcard/category'
import { filterWorldCountries, findWorldCountry } from '@/utils/worldCountries'

export default {
  name: 'GiftcardCategory',
  data() {
    return {
      selectedWorldCountryCode: undefined,
      worldCountryKeyword: '',
      activeTab: 'country',
      countryLoading: false,
      countrySubmitLoading: false,
      countryOpen: false,
      countryFormTitle: '',
      countryManageList: [],
      countryTotal: 0,
      countryQuery: { pageNum: 1, pageSize: 10 },
      countryForm: { id: null, name: '', code: '', currencySymbol: '', logoUrl: '', sort: 0, status: 1 },
      countryColumns: [
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '图标', dataIndex: 'logoUrl', scopedSlots: { customRender: 'logoUrl' }, width: 80 },
        { title: '国家名称', dataIndex: 'name', width: 140 },
        { title: '代码', dataIndex: 'code', width: 90 },
        { title: '货币符号', dataIndex: 'currencySymbol', width: 100 },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 120 }
      ],
      categoryLoading: false,
      categorySubmitLoading: false,
      categoryOpen: false,
      categoryFormTitle: '',
      categoryList: [],
      categoryTotal: 0,
      categoryQuery: { pageNum: 1, pageSize: 10 },
      categoryForm: { id: null, name: '', logoUrl: '', sort: 0, status: 1, needCardNumber: 0, needCardExpiry: 0, needCardPin: 0 },
      categoryColumns: [
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '名称', dataIndex: 'name', width: 120 },
        { title: 'Logo', dataIndex: 'logoUrl', scopedSlots: { customRender: 'logoUrl' }, width: 80 },
        { title: 'Card Number', dataIndex: 'needCardNumber', scopedSlots: { customRender: 'needCardNumber' }, width: 110 },
        { title: 'Expiry Date', dataIndex: 'needCardExpiry', scopedSlots: { customRender: 'needCardExpiry' }, width: 100 },
        { title: 'Card PIN', dataIndex: 'needCardPin', scopedSlots: { customRender: 'needCardPin' }, width: 90 },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 120 }
      ],
      countryList: [],
      categoryOptions: [],
      tierLoading: false,
      tierSubmitLoading: false,
      tierConfigSubmitLoading: false,
      tierGlobalConfig: { dailyNRate: undefined },
      tierSyncForm: {
        categoryId: undefined,
        minFaceValue: undefined,
        maxFaceValue: undefined,
        dailyCardRate: undefined,
        defaultPrice: 0
      },
      tierSyncMatchCount: 0,
      tierSyncSubmitting: false,
      tierSyncOpen: false,
      tierOpen: false,
      tierFormTitle: '',
      tierList: [],
      tierTotal: 0,
      tierQuery: { categoryId: undefined, countryId: undefined, cardType: undefined, pageNum: 1, pageSize: 10 },
      tierForm: { id: null, categoryId: undefined, countryId: undefined, cardType: 1, tierType: 1, minFaceValue: 0, maxFaceValue: 0, dailyCardRate: undefined, defaultPrice: 0, multiplier: null, sort: 0, status: 1 },
      tierColumns: [
        { title: 'ID', dataIndex: 'id', width: 70 },
        { title: '卡种', dataIndex: 'categoryId', scopedSlots: { customRender: 'categoryId' }, width: 100 },
        { title: '国家', dataIndex: 'countryId', scopedSlots: { customRender: 'countryId' }, width: 120 },
        { title: '卡类型', dataIndex: 'cardType', scopedSlots: { customRender: 'cardType' }, width: 80 },
        { title: '类型', dataIndex: 'tierType', scopedSlots: { customRender: 'tierType' }, width: 90 },
        { title: '面额区间', scopedSlots: { customRender: 'faceRange' }, width: 140 },
        { title: '当日卡汇率', dataIndex: 'dailyCardRate', scopedSlots: { customRender: 'dailyCardRate' }, width: 110 },
        { title: '当日N汇率', dataIndex: 'dailyNRate', scopedSlots: { customRender: 'dailyNRate' }, width: 110 },
        { title: '默认价格', scopedSlots: { customRender: 'defaultPrice' }, width: 100 },
        { title: '倍数', dataIndex: 'multiplier', scopedSlots: { customRender: 'multiplier' }, width: 80 },
        { title: '排序', dataIndex: 'sort', width: 70 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, width: 80 },
        { title: '操作', scopedSlots: { customRender: 'operation' }, width: 120 }
      ]
    }
  },
  computed: {
    tierFormDailyNRate () {
      return this.tierGlobalConfig.dailyNRate
    },
    isCountryEditing() {
      return !!this.countryForm.id
    },
    availableWorldCountries() {
      const existing = new Set((this.countryManageList || []).map(c => String(c.code || '').toUpperCase()))
      return filterWorldCountries(this.worldCountryKeyword).filter(c => !existing.has(c.code))
    }
  },
  created() {
    if (this.$route.path.indexOf('rate-tier') >= 0) {
      this.activeTab = 'tier'
    } else if (this.$route.path.indexOf('country') >= 0) {
      this.activeTab = 'country'
    }
    this.getCountryManageList()
    this.getCategoryList()
    this.loadCountries()
    this.loadCategoryOptions()
    this.loadTierGlobalConfig()
    this.getTierList()
  },
  methods: {
    formatRate(val) {
      if (val == null || val === '') return '—'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return num
    },
    formatDefaultPrice(val) {
      if (val == null || val === '') return '—'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return Math.round(num)
    },
    getCountryManageList() {
      this.countryLoading = true
      pageCountry(this.countryQuery).then(res => {
        this.countryManageList = res.data.records || []
        this.countryTotal = res.data.total || 0
      }).finally(() => { this.countryLoading = false })
    },
    changeCountryPage(page, pageSize) {
      this.countryQuery.pageNum = page
      this.countryQuery.pageSize = pageSize
      this.getCountryManageList()
    },
    resetCountryForm() {
      this.countryForm = { id: null, name: '', code: '', currencySymbol: '', logoUrl: '', sort: 0, status: 1 }
      this.selectedWorldCountryCode = undefined
      this.worldCountryKeyword = ''
    },
    closeCountryModal() {
      this.countryOpen = false
      this.resetCountryForm()
    },
    onWorldCountrySearch(keyword) {
      this.worldCountryKeyword = keyword
    },
    onWorldCountryPick(code) {
      const item = findWorldCountry(code)
      if (!item) {
        this.countryForm.name = ''
        this.countryForm.code = ''
        return
      }
      this.countryForm.name = item.name
      this.countryForm.code = item.code
      this.countryForm.currencySymbol = item.currencySymbol || ''
    },
    handleAddCountry() {
      this.resetCountryForm()
      this.countryFormTitle = '新增国家'
      this.countryOpen = true
    },
    handleEditCountry(record) {
      this.countryForm = { ...record }
      this.selectedWorldCountryCode = undefined
      this.worldCountryKeyword = ''
      this.countryFormTitle = '编辑国家'
      this.countryOpen = true
    },
    submitCountry() {
      if (!this.isCountryEditing && !this.selectedWorldCountryCode) {
        this.$message.warning('请选择国家')
        return
      }
      if (!this.countryForm.name || !this.countryForm.code) {
        this.$message.warning('请填写国家名称和代码')
        return
      }
      this.countrySubmitLoading = true
      saveCountry(this.countryForm).then(() => {
        this.$message.success('保存成功')
        this.closeCountryModal()
        this.getCountryManageList()
        this.loadCountries()
      }).finally(() => { this.countrySubmitLoading = false })
    },
    handleDeleteCountry(record) {
      const self = this
      this.$confirm({
        title: '确认删除该国家？',
        content: '若已配置阶梯价将无法删除',
        onOk() {
          return deleteCountry(record.id).then(() => {
            self.$message.success('删除成功')
            self.getCountryManageList()
            self.loadCountries()
          })
        }
      })
    },
    loadCountries() {
      listCountry().then(res => {
        this.countryList = res.data || []
      })
    },
    loadCategoryOptions() {
      pageCategory({ pageNum: 1, pageSize: 200 }).then(res => {
        this.categoryOptions = res.data.records || []
      })
    },
    categoryName(id) {
      const item = this.categoryOptions.find(c => c.id === id)
      return item ? item.name : id
    },
    countryName(id) {
      const item = this.countryList.find(c => c.id === id)
      return item ? item.name : id
    },
    getCategoryList() {
      this.categoryLoading = true
      pageCategory(this.categoryQuery).then(res => {
        this.categoryList = res.data.records || []
        this.categoryTotal = res.data.total || 0
      }).finally(() => { this.categoryLoading = false })
    },
    changeCategoryPage(page, pageSize) {
      this.categoryQuery.pageNum = page
      this.categoryQuery.pageSize = pageSize
      this.getCategoryList()
    },
    resetCategoryForm() {
      this.categoryForm = { id: null, name: '', logoUrl: '', sort: 0, status: 1, needCardNumber: 0, needCardExpiry: 0, needCardPin: 0 }
    },
    handleAddCategory() {
      this.resetCategoryForm()
      this.categoryFormTitle = '新增卡种'
      this.categoryOpen = true
    },
    handleEditCategory(record) {
      this.categoryForm = {
        ...record,
        needCardNumber: record.needCardNumber || 0,
        needCardExpiry: record.needCardExpiry || 0,
        needCardPin: record.needCardPin || 0
      }
      this.categoryFormTitle = '编辑卡种'
      this.categoryOpen = true
    },
    submitCategory() {
      if (!this.categoryForm.name) {
        this.$message.warning('请输入卡种名称')
        return
      }
      this.categorySubmitLoading = true
      saveCategory(this.categoryForm).then(() => {
        this.$message.success('保存成功')
        this.categoryOpen = false
        this.getCategoryList()
        this.loadCategoryOptions()
      }).finally(() => { this.categorySubmitLoading = false })
    },
    handleDeleteCategory(record) {
      const self = this
      this.$confirm({
        title: '确认删除该卡种？',
        onOk() {
          return deleteCategory(record.id).then(() => {
            self.$message.success('删除成功')
            self.getCategoryList()
            self.loadCategoryOptions()
          })
        }
      })
    },
    buildTierPageQuery() {
      const params = {
        pageNum: this.tierQuery.pageNum || 1,
        pageSize: this.tierQuery.pageSize || 10
      }
      const categoryId = this.tierQuery.categoryId
      if (categoryId !== undefined && categoryId !== null && categoryId !== '') {
        params.categoryId = String(categoryId)
      }
      const countryId = this.tierQuery.countryId
      if (countryId !== undefined && countryId !== null && countryId !== '') {
        params.countryId = String(countryId)
      }
      const cardType = this.tierQuery.cardType
      if (cardType !== undefined && cardType !== null && cardType !== '') {
        params.cardType = Number(cardType)
      }
      return params
    },
    handleTierQuery() {
      if (this.tierQuery.categoryId === null || this.tierQuery.categoryId === '') {
        this.tierQuery.categoryId = undefined
      }
      if (this.tierQuery.countryId === null || this.tierQuery.countryId === '') {
        this.tierQuery.countryId = undefined
      }
      if (this.tierQuery.cardType === null || this.tierQuery.cardType === '') {
        this.tierQuery.cardType = undefined
      }
      this.tierQuery.pageNum = 1
      this.getTierList()
    },
    getTierList() {
      this.tierLoading = true
      return pageRateTier(this.buildTierPageQuery()).then(res => {
        this.tierList = (res.data && res.data.records) || []
        this.tierTotal = (res.data && res.data.total) || 0
      }).finally(() => { this.tierLoading = false })
    },
    loadTierGlobalConfig() {
      return getRateTierConfig().then(res => {
        this.tierGlobalConfig = {
          dailyNRate: res.data && res.data.dailyNRate != null ? Number(res.data.dailyNRate) : undefined
        }
        this.recalcTierSyncDefaultPrice()
      })
    },
    buildTierSyncQueryParams() {
      const p = { pageNum: 1, pageSize: 1, categoryId: this.tierSyncForm.categoryId }
      if (this.tierSyncForm.minFaceValue != null) p.minFaceValue = this.tierSyncForm.minFaceValue
      if (this.tierSyncForm.maxFaceValue != null) p.maxFaceValue = this.tierSyncForm.maxFaceValue
      return p
    },
    resetTierSyncForm() {
      this.tierSyncForm = {
        categoryId: undefined,
        minFaceValue: undefined,
        maxFaceValue: undefined,
        dailyCardRate: undefined,
        defaultPrice: 0
      }
      this.tierSyncMatchCount = 0
    },
    openTierSyncDrawer() {
      this.resetTierSyncForm()
      this.tierSyncOpen = true
      this.loadTierGlobalConfig().then(() => {
        if (this.tierQuery.categoryId) {
          this.tierSyncForm.categoryId = this.tierQuery.categoryId
          this.refreshTierSyncMatchCount()
        }
      })
    },
    closeTierSyncDrawer() {
      this.tierSyncOpen = false
    },
    refreshTierSyncMatchCount() {
      if (!this.tierSyncForm.categoryId) {
        this.tierSyncMatchCount = 0
        return Promise.resolve()
      }
      return pageRateTier(this.buildTierSyncQueryParams()).then(res => {
        this.tierSyncMatchCount = res.data.total || 0
      })
    },
    recalcTierSyncDefaultPrice() {
      const cardRate = Number(this.tierSyncForm.dailyCardRate)
      const nRate = Number(this.tierGlobalConfig.dailyNRate)
      if (!cardRate || cardRate <= 0 || !nRate || nRate <= 0) {
        this.tierSyncForm.defaultPrice = 0
        return
      }
      this.tierSyncForm.defaultPrice = Math.round(cardRate * nRate)
    },
    submitTierSync() {
      if (!this.tierSyncForm.categoryId) {
        this.$message.warning('请选择卡种')
        return
      }
      if (this.tierGlobalConfig.dailyNRate == null || this.tierGlobalConfig.dailyNRate <= 0) {
        this.$message.warning('请先在列表页「全局配置」中设置当日N汇率')
        return
      }
      if (this.tierSyncForm.dailyCardRate == null || this.tierSyncForm.dailyCardRate <= 0) {
        this.$message.warning('请填写大于0的当日卡汇率')
        return
      }
      if (this.tierSyncForm.minFaceValue != null && this.tierSyncForm.maxFaceValue != null
        && this.tierSyncForm.minFaceValue > this.tierSyncForm.maxFaceValue) {
        this.$message.warning('面额下限不能大于上限')
        return
      }
      this.recalcTierSyncDefaultPrice()
      const self = this
      this.refreshTierSyncMatchCount().then(() => {
        if (self.tierSyncMatchCount <= 0) {
          self.$message.warning('当前条件下无匹配阶梯价')
          return
        }
        self.$confirm({
          title: '确认批量同步？',
          content: `将更新 ${self.tierSyncMatchCount} 条阶梯价，默认价格=${self.tierSyncForm.defaultPrice}`,
          onOk() {
            self.tierSyncSubmitting = true
            return syncRateTier({
              categoryId: self.tierSyncForm.categoryId,
              minFaceValue: self.tierSyncForm.minFaceValue,
              maxFaceValue: self.tierSyncForm.maxFaceValue,
              dailyCardRate: self.tierSyncForm.dailyCardRate
            }).then(res => {
              const count = (res.data && res.data.updatedCount) || self.tierSyncMatchCount
              self.$message.success(`已同步 ${count} 条`)
              self.tierSyncOpen = false
              self.getTierList()
            }).finally(() => { self.tierSyncSubmitting = false })
          }
        })
      })
    },
    submitTierGlobalConfig() {
      if (this.tierGlobalConfig.dailyNRate == null || this.tierGlobalConfig.dailyNRate <= 0) {
        this.$message.warning('请填写大于0的当日N汇率')
        return
      }
      this.tierConfigSubmitLoading = true
      saveRateTierConfig({ dailyNRate: this.tierGlobalConfig.dailyNRate }).then(() => {
        this.$message.success('全局配置已保存，列表默认价格已重新计算')
        return Promise.all([this.loadTierGlobalConfig(), this.getTierList()])
      }).finally(() => { this.tierConfigSubmitLoading = false })
    },
    recalcTierDefaultPrice() {
      const cardRate = Number(this.tierForm.dailyCardRate)
      const nRate = Number(this.tierGlobalConfig.dailyNRate)
      if (!cardRate || cardRate <= 0 || !nRate || nRate <= 0) {
        this.tierForm.defaultPrice = 0
        return
      }
      this.tierForm.defaultPrice = Math.round(cardRate * nRate)
    },
    changeTierPage(page, pageSize) {
      this.tierQuery.pageNum = page
      this.tierQuery.pageSize = pageSize
      this.getTierList()
    },
    resetTierForm() {
      this.tierForm = { id: null, categoryId: undefined, countryId: undefined, cardType: 1, tierType: 1, minFaceValue: 0, maxFaceValue: 0, dailyCardRate: undefined, defaultPrice: 0, multiplier: null, sort: 0, status: 1 }
    },
    onTierTypeChange() {
      if (this.tierForm.tierType === 1) {
        this.tierForm.multiplier = null
      }
    },
    handleAddTier() {
      this.resetTierForm()
      this.loadTierGlobalConfig().then(() => {
        this.tierFormTitle = '新增面额阶梯价'
        this.tierOpen = true
      })
    },
    handleEditTier(record) {
      this.loadTierGlobalConfig().then(() => {
        let dailyCardRate = record.dailyCardRate != null ? Number(record.dailyCardRate) : undefined
        if ((dailyCardRate == null || Number.isNaN(dailyCardRate)) && record.defaultPrice != null && this.tierGlobalConfig.dailyNRate > 0) {
          dailyCardRate = Number(record.defaultPrice != null ? record.defaultPrice : record.rate) / Number(this.tierGlobalConfig.dailyNRate)
        }
        this.tierForm = {
          ...record,
          tierType: record.tierType || 1,
          dailyCardRate: dailyCardRate != null && !Number.isNaN(dailyCardRate) ? Number(dailyCardRate.toFixed(4)) : undefined,
          defaultPrice: Math.round(Number(record.defaultPrice != null ? record.defaultPrice : record.rate))
        }
        this.recalcTierDefaultPrice()
        this.tierFormTitle = '编辑面额阶梯价'
        this.tierOpen = true
      })
    },
    submitTier() {
      if (!this.tierForm.categoryId || !this.tierForm.countryId) {
        this.$message.warning('请选择卡种和国家')
        return
      }
      if (this.tierGlobalConfig.dailyNRate == null || this.tierGlobalConfig.dailyNRate <= 0) {
        this.$message.warning('请先在页面顶部配置当日N汇率')
        return
      }
      if (this.tierForm.minFaceValue == null || this.tierForm.maxFaceValue == null) {
        this.$message.warning('请填写面额区间')
        return
      }
      if (this.tierForm.dailyCardRate == null || this.tierForm.dailyCardRate <= 0) {
        this.$message.warning('请填写大于0的当日卡汇率')
        return
      }
      this.recalcTierDefaultPrice()
      if (this.tierForm.defaultPrice == null || this.tierForm.defaultPrice <= 0) {
        this.$message.warning('默认价格计算无效，请检查汇率')
        return
      }
      if (this.tierForm.tierType === 2 && this.tierForm.multiplier != null && this.tierForm.multiplier <= 0) {
        this.$message.warning('倍数须大于0')
        return
      }
      this.tierSubmitLoading = true
      saveRateTier(this.tierForm).then(() => {
        this.$message.success('保存成功')
        this.tierOpen = false
        this.getTierList()
      }).finally(() => { this.tierSubmitLoading = false })
    },
    handleDeleteTier(record) {
      const self = this
      this.$confirm({
        title: '确认删除该阶梯价？',
        onOk() {
          return deleteRateTier(record.id).then(() => {
            self.$message.success('删除成功')
            self.getTierList()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.card-field-checks .ant-checkbox-wrapper { display: block; margin-left: 0; margin-bottom: 8px; }
.form-tip { color: rgba(0, 0, 0, 0.45); font-size: 12px; margin-top: 4px; }
.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
}
</style>
